import { sineInOut } from 'svelte/easing'

export default function (node, params) {
    const { delay = 0, duration = 200, easing = sineInOut } = params

    return {
        delay,
        duration,
        easing,
        css: (t) =>
            `backdrop-filter: blur(${t * 15}px);background: rgba(32, 37, 43, ${t * 0.6});`,
    }
}
